import { render, staticRenderFns } from "./shop-detail.html?vue&type=template&id=495626bc&scoped=true&"
import script from "./shop-detail.js?vue&type=script&lang=js&"
export * from "./shop-detail.js?vue&type=script&lang=js&"
import style0 from "./shop-detail.scss?vue&type=style&index=0&id=495626bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495626bc",
  null
  
)

export default component.exports